// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  imported from Link.module.scss  */
.Link-module-Root_1TV {
  font-family: var(--control-font-family);
  text-decoration: none;
  outline: 0;
  transition: color 0.15s linear;
  touch-action: manipulation;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0); }
  .Link-module-Root_1TV[aria-disabled='true'] {
    pointer-events: none;
    color: rgba(38, 49, 129, 0.3); }
  .Link-module-Root_1TV[type='button'] {
    font-size: 1rem;
    cursor: pointer;
    border: 0;
    background: transparent; }
  .Link-module-Root_1TV:focus-visible {
    border-radius: 4px;
    outline: 2px solid; }

/* Variants */
.Link-module-defaultVariant_143 {
  color: #8168f0; }
  .Link-module-defaultVariant_143:hover {
    color: #6345dc; }

.Link-module-blackVariant_2QV {
  color: #000; }
  .Link-module-blackVariant_2QV:hover {
    color: #8168f0; }

.Link-module-successVariant_3Qk {
  color: var(--link-color-success); }
  .Link-module-successVariant_3Qk:hover {
    color: var(--link-color-success-hover); }

.Link-module-warningVariant_8TB {
  color: var(--link-color-warning); }
  .Link-module-warningVariant_8TB:hover {
    color: var(--link-color-warning-hover); }

.Link-module-dangerVariant_1Un {
  color: var(--link-color-danger); }
  .Link-module-dangerVariant_1Un:hover {
    color: var(--link-color-danger-hover); }

/* Underlines */
.Link-module-dashedUnderline_3bo {
  border-bottom: 1px dashed; }

.Link-module-solidUnderline_11l {
  border-bottom: 1px solid; }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/components/Link/Link.css"],"names":[],"mappings":"AAAA,qCAAqC;AACrC;EACE,uCAAuC;EACvC,qBAAqB;EACrB,UAAU;EACV,8BAA8B;EAC9B,0BAA0B;EAC1B,6CAA6C,EAAE;EAC/C;IACE,oBAAoB;IACpB,6BAA6B,EAAE;EACjC;IACE,eAAe;IACf,eAAe;IACf,SAAS;IACT,uBAAuB,EAAE;EAC3B;IACE,kBAAkB;IAClB,kBAAkB,EAAE;;AAExB,aAAa;AACb;EACE,cAAc,EAAE;EAChB;IACE,cAAc,EAAE;;AAEpB;EACE,WAAW,EAAE;EACb;IACE,cAAc,EAAE;;AAEpB;EACE,gCAAgC,EAAE;EAClC;IACE,sCAAsC,EAAE;;AAE5C;EACE,gCAAgC,EAAE;EAClC;IACE,sCAAsC,EAAE;;AAE5C;EACE,+BAA+B,EAAE;EACjC;IACE,qCAAqC,EAAE;;AAE3C,eAAe;AACf;EACE,yBAAyB,EAAE;;AAE7B;EACE,wBAAwB,EAAE","sourcesContent":["/*  imported from Link.module.scss  */\n.Link-module-Root_1TV {\n  font-family: var(--control-font-family);\n  text-decoration: none;\n  outline: 0;\n  transition: color 0.15s linear;\n  touch-action: manipulation;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0); }\n  .Link-module-Root_1TV[aria-disabled='true'] {\n    pointer-events: none;\n    color: rgba(38, 49, 129, 0.3); }\n  .Link-module-Root_1TV[type='button'] {\n    font-size: 1rem;\n    cursor: pointer;\n    border: 0;\n    background: transparent; }\n  .Link-module-Root_1TV:focus-visible {\n    border-radius: 4px;\n    outline: 2px solid; }\n\n/* Variants */\n.Link-module-defaultVariant_143 {\n  color: #8168f0; }\n  .Link-module-defaultVariant_143:hover {\n    color: #6345dc; }\n\n.Link-module-blackVariant_2QV {\n  color: #000; }\n  .Link-module-blackVariant_2QV:hover {\n    color: #8168f0; }\n\n.Link-module-successVariant_3Qk {\n  color: var(--link-color-success); }\n  .Link-module-successVariant_3Qk:hover {\n    color: var(--link-color-success-hover); }\n\n.Link-module-warningVariant_8TB {\n  color: var(--link-color-warning); }\n  .Link-module-warningVariant_8TB:hover {\n    color: var(--link-color-warning-hover); }\n\n.Link-module-dangerVariant_1Un {\n  color: var(--link-color-danger); }\n  .Link-module-dangerVariant_1Un:hover {\n    color: var(--link-color-danger-hover); }\n\n/* Underlines */\n.Link-module-dashedUnderline_3bo {\n  border-bottom: 1px dashed; }\n\n.Link-module-solidUnderline_11l {\n  border-bottom: 1px solid; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
